import colors from 'styles/theme/colors';

export default function ChevronDownSmall({
  width = 7,
  height = 5,
  color = colors.black100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 7 5' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.29927 0C6.1134 4.72069e-05 5.93516 0.0878787 5.80375 0.244175L3.49577 2.98844L1.18778 0.244175C1.0556 0.0923719 0.878553 0.00837374 0.694786 0.0102725C0.511018 0.0121708 0.33523 0.0998149 0.205282 0.254327C0.0753338 0.408839 0.00162338 0.617857 2.6495e-05 0.836362C-0.00157039 1.05487 0.0690739 1.26538 0.196744 1.42255L3.00025 4.756C3.13168 4.91223 3.30992 5 3.49577 5C3.68162 5 3.85985 4.91223 3.99129 4.756L6.79479 1.42255C6.89278 1.306 6.95951 1.15753 6.98654 0.995895C7.01357 0.834261 6.99969 0.666728 6.94666 0.514473C6.89362 0.362218 6.80381 0.232077 6.68858 0.140503C6.57335 0.0489302 6.43787 3.52859e-05 6.29927 0Z'
        fill={color}
      />
    </svg>
  );
}
